import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  INCOMPLETE_ORDERS_REQUESTED,
  INCOMPLETE_ORDERS_SUCCESS,
  ORDER_SHIPMENTS_REQUESTED,
  ORDER_SHIPMENTS_SUCCESS,
} from '../types';

export const incompleteOrdersRequested = () => {
  return {
    type: INCOMPLETE_ORDERS_REQUESTED
  }
};

export const incompleteOrdersSuccess = (orders) => {
  return {
    type: INCOMPLETE_ORDERS_SUCCESS,
    payload: orders
  }
};

export const incompleteOrderShipmentsRequested = (orderId) => {
  return {
    type: ORDER_SHIPMENTS_REQUESTED,
    payload: orderId
  }
}

export const incompleteOrderShipmentsSuccess = (shipments) => {
  return {
    type: ORDER_SHIPMENTS_SUCCESS,
    payload: shipments
  }
}

export const getIncompleteOrders = (signedPayload, orderPage, searchSuspendedOrders) => {
  return (dispatch) => {
    dispatch(incompleteOrdersRequested());

    let endPoint = Config.baseUrl + Config.orders + Config.incomplete + `?page=${orderPage}&suspended=${searchSuspendedOrders.toString()}`;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(incompleteOrdersSuccess(response.data));
      })
  }
}

export const getOrderShipments = (signedPayload, orderId) => {
  return (dispatch) => {
    dispatch(incompleteOrderShipmentsRequested(orderId));

    let endPoint = Config.baseUrl + Config.order + `/${orderId}/` + Config.shipments;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(incompleteOrderShipmentsSuccess(response.data));
      })
  }
}